import { OutlinedPrimaryButton } from "components/button";
import styled from "styled-components";

export const Button = styled(OutlinedPrimaryButton)`
  min-width: 100px;
`
